// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"242":"f56ba17f","703":"d49a513b"}[chunkId] + ".chunk.js";
};